// axios.js
import axios from 'axios';
import store from '@/store/index';
import router from "@/router/index";

export function axiosDefault(config, cancelToken) {
  const instance = axios.create({
    baseURL: config.WebApiUrl,
  });

  instance.interceptors.request.use((config) => {
    if (cancelToken) {
      config.cancelToken = cancelToken;
    }
    return config;
  });

  return instance;
}

export function axiosWAuth(config, cancelToken) {
  const instance = axios.create({
    baseURL: config.WebApiUrl,
    withCredentials: true,
  });

  instance.interceptors.request.use(
    config => {
      // Check if the application is in maintenance mode and reject request
      if (store.getters.getMaintenanceStatus) {
        return Promise.reject(new axios.Cancel("Application is in maintenance mode"));
      }

      config.headers.common = {
        ...config.headers.common,
        Authorization: 'Bearer ' + store.getters.getAccessToken,
      };
      if (cancelToken) {
        config.cancelToken = cancelToken;
      }
      return config;
    },
    error => Promise.reject(error),
  );

  instance.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response.status === 401) {
            return new Promise((resolve, reject) => {
                store.dispatch("logout")
                window.location.href = config.WebCaatAuthWebUrl + "?returnUrl=" + config.LinkOnlineAnalys
                reject(error)
            })
        } else if (error.response.status === 403 && error.response.data.errorCode === "NON_MMS_USER") {
            store.commit("setMaintenanceStatus", true)
            if (router.history.current.path !== "/maintenance") router.push("/maintenance")
            console.error("Specific 403 error:", error.response.data.errorCode)
        }
        // Generic error handler
        return Promise.reject(error)
    }
  );

  return instance;
}
